// extracted by mini-css-extract-plugin
export var cls1 = "index-module--cls1--EDDgZ";
export var cls2 = "index-module--cls2--mOF7n";
export var cls4 = "index-module--cls4--CmqzV";
export var cls5 = "index-module--cls5--DlOKj";
export var cls6 = "index-module--cls6--xmzcp";